import card, { cardVariants, CardVariantsType as ICardVariantsType } from './card';

export type CardVariantsType = ICardVariantsType;

export { cardVariants };
export default card;
